
export default {
  // Navigation-related translations
  "home": "首页",
  "profile": "个人资料",
  "airports": "机场",
  "inventory": "库存",
  "admin": "管理员",
  "resources": "资源",
  "develop": "冲洗",
  // "light_meter": "测光表" // Commented out to hide from navigation
};
